import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';

import AllStatusResponse from './AllStatusResponse';

export function getRequestTasksAllStatus(
  workspaceId: string,
  bulkRequestId: string
): Promise<AllStatusResponse> {
  return requestApi<AllStatusResponse>({
    url: withBulkRequest(
      `/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/request-tasks/all/status`
    ),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}
